import { Entity, EntityAspect, EntityType } from 'breeze-client';
import { Observable } from 'rxjs';

export class BaseEntity implements Entity {
    entityAspect: EntityAspect;
    entityType: EntityType;

    createdBy?: string;
    createdDate?: Date;
    ts?: string;
    updatedBy?: string;
    updatedDate?: Date;

    // for internal use
    _permissions$: Observable<string[]>;
}
